import { Link } from "react-router";

import NoParticipantsSvg from "@/../../hypetrain/static/img/program/no-participants.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box } from "@/components/layout/flexbox";

export const EmptyParticipant = ({ programId }: { programId: string }) => {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <EmbedSvg src={NoParticipantsSvg} width={48} height={48} />
      <Box my={2}>No Participants Yet</Box>
      <Link
        to={`/programs/${programId}/participants`}
        className="text-primary-500 font-medium border-dashed border-2 border-primary-500 rounded-md px-4 py-1 mt-2"
      >
        + Add Participants
      </Link>
    </div>
  );
};
